// icons
import type { IconifyIcon } from '@iconify/react';
import { Icon } from '@iconify/react';
// @mui
import type { BoxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';
import { unstable_extendSxProp as extendSxProp } from '@mui/system';
import type { SystemProps } from '@mui/system/Box';

import type { JSX } from 'react';

// ----------------------------------------------------------------------

// MUI v9 drops Box's top-level system props (width, color, mt, ...) from both
// its types and its runtime. extendSxProp is exactly what v7's Box called internally, so
// folding it in here keeps every call site working unchanged across the upgrade. It is
// idempotent, so this is a no-op on v7. Remove once call sites move to `sx`.
type Props = BoxProps &
  SystemProps<Theme> & {
    icon: IconifyIcon | string;
  };

export function Iconify({ icon, ...other }: Props): JSX.Element {
  return <Box component={Icon} icon={icon} {...extendSxProp(other)} />;
}
